import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const CtaBanner = () => {
  const navigate = useNavigate()
    
  const navigateLink = (link) => {
    navigate(link)
    window.scrollTo(0, 0)
  }

  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #0A9B48 0%, #087D3A 100%)',
        py: { xs: 4, md: 6 },
        px: 3,
      }}
    >
      <Box
        sx={{
          maxWidth: '900px',
          mx: 'auto',
          textAlign: 'center',
        }}
      >
        <Typography
          sx={{
            color: '#fff',
            opacity: 0.9,
            letterSpacing: '4px',
            textTransform: 'uppercase',
            mb: 2,
            fontSize: '0.9rem',
            fontWeight: 600,
          }}
        >
          Pulse Pallets
        </Typography>

        <Typography
          variant="h4"
          sx={{
            color: '#fff',
            fontWeight: 700,
            mb: 3,
          }}
        >
          Need Pallets For Your Business?
        </Typography>

        <Typography
          sx={{
            color: '#fff',
            fontSize: {
              xs: '1.05rem',
              md: '1.25rem',
            },
            lineHeight: 1.8,
            maxWidth: '700px',
            mx: 'auto',
            mb: 5,
            opacity: 0.95,
          }}
        >
          Whether you require a small quantity of pallets or ongoing supply,
          Pulse Pallets provides reliable pallet solutions tailored to your
          business requirements. Get in touch today to see how we can help.
        </Typography>

        <Button
          size="large"
          onClick={() => navigateLink('/contact')}
          sx={{
            border: '2px solid #fff',
            color: '#fff',
            minWidth: '220px',
            py: 2,
            px: 4,
            fontSize: '1rem',
            fontWeight: 700,
            letterSpacing: '1px',
            borderRadius: 0,
            backgroundColor: 'transparent',
            boxSizing: 'border-box',

            '&:hover': {
              border: '2px solid #57C84D',
              backgroundColor: 'transparent',
              transform: 'translateY(-5px)',
            }
          }}
        >
          GET A QUOTE →
        </Button>
      </Box>
    </Box>
  )
}

export default CtaBanner